export default function<T = null>(options: AppAlertConfigOptions<T>) {
    return {
        bodyAlert: {
            ...options
        }
    };
}

/*
 *Параметр fallbackApi будет передан и использован в следующих случаях:
 *
 *1. Отсутствие ответа от сервера:
 *    Если сервер не отвечает или произошла сетевая ошибка, и объект error.response не существует,
 *    создается новый объект error.response со статусом HTTP_INTERNAL_SERVER_ERROR (500).
 *    В этом случае будет использован fallbackApi, если данные от сервера отсутствуют.
 *
 *2. Внутренняя ошибка сервера (500):
 *Если сервер возвращает статус HTTP_INTERNAL_SERVER_ERROR (500), то:
 *- Устанавливается флаг isCritical в true.
 *- Заголовок и описание ошибки устанавливаются
 *    в "An internal server error occurred!"
 *    и "Please try again later..." соответственно.
 *- Если данные ответа от сервера отсутствуют, будет использован fallbackApi.
 *
 *3.Обработка исключенных статусов:
 *    - Если HTTP-статус ответа не исключен в массиве exclude, то данные ответа от сервера будут заменены на данные из fallbackApi,
 *    - Если сервер не вернул данные (например, если error.response.content отсутствует).
 */
